export default __webpack_public_path__ + "static/media/convert.f9c69425.svg";